
namespace Matrix.Exceptions {

    function findEntityType(name: string): EntityTypeItem {
        var lookup = Q.getLookup<EntityTypeItem>('Workflow.EntityType');
        var item = lookup.itemById[name];
        if (item)
            return item;

        var regex = /[\[\]]/g;
        var normalize = function (s) {
            return (s ?? '').replace(regex, '').toLowerCase();
        }
        name = normalize(name);
        return Q.tryFirst(lookup.items, x =>
            name == normalize(x.EntityType) ||
            name == normalize(x.TableName));
    }

    export function renderExceptionDialogLink(ul: JQuery, dialogType: any, entityId: any, htmlContent: string) {
        $(`<li><a href="javascript:;" class="dropdown-item" data-dialog="${Q.attrEncode(Q.getTypeFullName(dialogType))}" 
            data-key="${Q.attrEncode(entityId)}">${htmlContent}</a></li>`)
            .appendTo(ul);
    }

    export function renderExceptionLinks(ul: JQuery, links: Exceptions.ExceptionLinkRow[]) {
        for (var link of links) {
            var entityType = findEntityType(link.LinkToSchema + '.' + link.LinkToTable);
            if (!entityType && !link.LinkToUrl) {
                $(`<li>Unknown link: ${Q.htmlEncode(link.LinkToSchema + '.' + link.LinkToTable)} - ${link.LinkToEntityKey}!</li>`)
                    .appendTo(ul);
                continue;
            }

            var text: string;
            var linkToUrl = Q.attrEncode(Q.resolveUrl(link.LinkToUrl));

            if (entityType) {

                text = Q.htmlEncode(link.LinkToText ? link.LinkToText : ((entityType.InstanceName ?? entityType.DisplayName) + ': ' + link.LinkToEntityKey));

                if (!link.LinkToUrl) {
                    var dialogType = Serenity.DialogTypeRegistry.tryGet(entityType.EntityType) ??
                        Serenity.DialogTypeRegistry.tryGet(entityType.EntityType + "Dialog");

                    if (!dialogType) {
                        $(`<li>Unknown dialog "${Q.htmlEncode(entityType.EntityType)}" for: ${text}!</li>`)
                            .appendTo(ul);
                        continue;
                    }

                    renderExceptionDialogLink(ul, dialogType, link.LinkToEntityKey, text)
                }
                else {
                    $(`<li><a href="${linkToUrl}" class="dropdown-item">${text}</a></li>`)
                        .appendTo(ul);
                }

            }
            else {
                text = link.LinkToText ? Q.htmlEncode(link.LinkToText) : linkToUrl;
                $(`<li><a href="${linkToUrl}" class="dropdown-item">${text}</a></li>`)
                    .appendTo(ul);
            }
        }
    }

    export function handleExceptionLinkClick(e: Event) {
        var a = $(e.currentTarget);
        var dialog = a.attr('data-dialog');
        if (dialog == null)
            return;

        var key = a.attr('data-key');
        var dialogType = Serenity.DialogTypeRegistry.get(dialog);
        var dlg = new dialogType();
        dlg.loadByIdAndOpenDialog(key);
    }

    export interface JsonViewerOptions {
        height: number;
    }
}